import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import OrderManagementApiService from 'Service/OrderManagement/OrderManagementApiService';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_BULK_ORDER_FLEET_HEADER, SAVE_CANCEL_BULK_ORDER, GET_BULK_ORDER_HEADER, GET_BULK_ORDER_PURCHASE_ORDER, GET_BULK_ORDER_VENDOR_DETAILS, GET_SAVE_VENDOR_DETAILS, SAVE_BULK_ORDER_FLEET_PURCHASE_DETAIL, GET_BULK_ORDER_FLEET_PURCHASE_DETAIL, SAVE_BULK_ORDER_FLEET_ASSET, GET_BULK_ORDER_DESCRIPTION_DROPDOWN, GET_BULK_ORDER_EXCEL_DATA, GET_TASK_HEADER_DETAILS, GET_TASK_ITEM_DETAILS, GET_CREATE_BULK_PO_DETAILS, GET_BULK_FLEET_HISTORY_TIMELINE, SAVE_TASK_ASSIGNED_TO, SAVE_TASK_COMMENT, SAVE_CANCEL_FLEET_ITEM, GET_SAVE_BULK_FLEET_PURCHASE_ORDER, SAVE_BULK_ORDER_FLEET_BARCODE } from 'Store/Component/PurchaseBulkOrder/PurchaseBulkOrderType';
import { setBulkFleetHistoryTimeLine, setBulkOrderDescriptionDropdown, setBulkOrderExcelData, setBulkOrderFleetAsset, setBulkOrderFleetBarcode, setBulkOrderFleetHeader, setBulkOrderFleetPurchaseDetail, setBulkOrderHeader, setBulkOrderPurchaseOrder, setBulkOrderVendorDetails, setCancelBulkOrder, setCancelFleetItem, setCreatePODetails, setSaveBulkFleetPurchaseDetail, setSaveBulkFleetPurchaseOrder, setSaveVendorDetails, setTaskAssignedTo, setTaskComment, setTaskHeaderDetails, setTaskItemDetails } from 'Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction';
import { GET_BULK_ORDER_FLEET_ATTACHMENTS } from 'Store/Component/BulkOrder/BulkOrderType';
import { setBulkOrderFleetAttachments } from 'Store/Component/BulkOrder/BulkOrderAction';

function* getBulkOrderHeader(orderId: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/orderheader/${orderId?.orderId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setBulkOrderHeader(response));
            yield put(globalLoaderText(""));
        } else {
            yield put(globalLoaderText(""));
            yield put(setBulkOrderHeader(null));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBulkOrderHeader(null));
    }
}

function* getBulkOrderFleetHeader(fleetId: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/fleetheader/${fleetId?.fleetId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            response?.map((item?: any) => {
                item.orderId = fleetId?.fleetId
                item.isVendorChanged = false
                if (item?.vendorDetails?.vendorName) {
                  item.isVendorSaved = true
                } else {
                  item.isVendorSaved = false
                }
              })
            yield put(setBulkOrderFleetHeader(response));
            yield put(globalLoaderText(""));
        }else{
            yield put(globalLoaderText(""));
            yield put(setBulkOrderFleetHeader(null));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBulkOrderFleetHeader(null));
    }
}

function* getBulkOrderFleetPurchaseDetail(fleetId: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/purchasedetails/${fleetId?.fleetId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setBulkOrderFleetPurchaseDetail(response));
            yield put(globalLoaderText(""));
        }else{
            yield put(globalLoaderText(""));
            yield put(setBulkOrderFleetPurchaseDetail(null));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBulkOrderFleetPurchaseDetail(null));
    }
}

function* getBulkOrderPurchaseOrderSaga(fleetId: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/podetails/${fleetId?.orderDetailId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            let val: any = {}
            val.orderDetailId = fleetId?.orderDetailId
            val.response = response
            yield put(setBulkOrderPurchaseOrder(val));
            yield put(globalLoaderText(""));
        }else{
            yield put(globalLoaderText(""));
            yield put(setBulkOrderPurchaseOrder(null));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBulkOrderPurchaseOrder(null));
    }
}

function* saveBulkOrderFleetAsset(payload: any): any {
    try {
        yield put(globalLoaderText("Saving Asset ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/asset`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setBulkOrderFleetAsset(response));
            yield put(globalLoaderText(""));
        }else{
            yield put(setBulkOrderFleetAsset({validationMessage:'Please enter valid Asset#', isValid: false, assetNumber: payload?.payload?.assetNumber, fleetRequestDetailId: payload?.payload?.fleetDetailId}));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setBulkOrderFleetAsset({validationMessage:'Please enter valid Asset#', isValid: false, assetNumber: payload?.payload?.assetNumber, fleetRequestDetailId: payload?.payload?.fleetDetailId}));
        yield put(globalLoaderText(""));
    }
}

function* getBulkOrderExcelData(orderDetailId: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/fleetdetail/export/${orderDetailId?.orderDetailId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setBulkOrderExcelData(response));
            yield put(globalLoaderText(""));
        }else{
            yield put(setBulkOrderExcelData([]));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setBulkOrderExcelData([]));
        yield put(globalLoaderText(""));
    }
}

function* getTaskHeaderDetails(orderDetailId: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/tasks/${orderDetailId?.orderDetailId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        const list = {
            data: response,
            orderDetailId: orderDetailId.orderDetailId
        }

        if (response) {
            yield put(setTaskHeaderDetails(list));
            yield put(globalLoaderText(""));
        }else{
            yield put(setTaskHeaderDetails([]));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setTaskHeaderDetails([]));
        yield put(globalLoaderText(""));
    }
}

function* getTaskItemDetails(fleetDetailId: any): any {
    try {
        const fleetId = fleetDetailId?.fleetDetailId
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/item/task/${fleetId.fleetDetailId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        const list = {
            data: response,
            orderDetailId: fleetId.orderDetailId,
            fleetDetailId: fleetId.fleetDetailId
        }
        
        if (response) {
            yield put(setTaskItemDetails(list));
            yield put(globalLoaderText(""));
        }else{
            yield put(setTaskItemDetails([]));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setTaskItemDetails([]));
        yield put(globalLoaderText(""));
    }
}

function* saveTaskAssignedTo(payload: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/item/assignedTo`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        
        const list = {
            data: response,
            fleetDetailId: payload.payload.fleetDetailId
        }

        yield put(setTaskAssignedTo(list));
        yield put(globalLoaderText(""));
    
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* saveTaskComment(payload: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/item/comments`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        
        const list = {
            data: response,
            fleetDetailId: payload.payload.fleetDetailId
        }

        yield put(setTaskComment(list));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* saveCancelFleetItem(payload: any): any {
    try {
        yield put(globalLoaderText("Cancel Item ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/item/cancel`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        let responseTemp = response
        responseTemp.cancelComments =payload.payload.comments
        yield put(setCancelFleetItem(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* saveCancelBulkOrder(payload: any): any {
    try {
        yield put(globalLoaderText("Cancel Item ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/item/cancel/SuperAdmin`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        // let responseTemp = response
        // responseTemp.cancelComments =payload.payload.comments

        yield put(setCancelBulkOrder(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* getBulkOrderDescriptionDropdown(orderDetailId: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.AssetManagement,
            endpoint: `assets/bulkorder/vehiclemanagedequipment/catalogspecification/${orderDetailId?.orderDetailId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        const list = {
            data: response,
            orderDetailId: orderDetailId.orderDetailId
        }
        if (response) {
            yield put(setBulkOrderDescriptionDropdown(list));
            yield put(globalLoaderText(""));
        }else{
            yield put(setBulkOrderDescriptionDropdown([]));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setBulkOrderDescriptionDropdown([]));
        yield put(globalLoaderText(""));
    }
}

function* saveBulkOrderFleetPurchaseDetail(payload: any): any {
    try {
        yield put(globalLoaderText("Saving value ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/purchasedetail`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setSaveBulkFleetPurchaseDetail({isSaved: response.success, orderDetailId: payload?.payload?.orderDetailId,total : response?.totalAmount}))
        }else{
            yield put(globalLoaderText(""));
            yield put(setSaveBulkFleetPurchaseDetail({isSaved: false, orderDetailId: payload?.payload?.orderDetailId}))
        }
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setSaveBulkFleetPurchaseDetail({isSaved: false, orderDetailId: payload?.payload?.orderDetailId}))
    }
}

function* saveBulkOrderFleetPurchaseOrder(payload: any): any {
    try {
        yield put(globalLoaderText("Saving value ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/purchaseorder`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(globalLoaderText(""));
            yield put(setSaveBulkFleetPurchaseOrder({ isSaved: response, orderDetailId: payload?.payload?.orderDetailId }))
        } else {
            yield put(globalLoaderText(""));
            yield put(setSaveBulkFleetPurchaseOrder({ isSaved: false, orderDetailId: payload?.payload?.orderDetailId }))
        }
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setSaveBulkFleetPurchaseOrder({ isSaved: false, orderDetailId: payload?.payload?.orderDetailId }))
    }
}

function* getBulkOrderVendorDetails(payload: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/vendordetails/${payload?.orderDetailId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            let val: any = {}
            val.orderDetailId = payload?.orderDetailId
            val.response = response
            yield put(setBulkOrderVendorDetails(response));
            yield put(globalLoaderText(""));
        }else{
            yield put(globalLoaderText(""));
            yield put(setBulkOrderVendorDetails(null));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBulkOrderVendorDetails(null));
    }
}

function* getSaveVendorDetails(payload: any): any {
    try {
        yield put(globalLoaderText("Saving values ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/vendor`,
            payload: payload?.details
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            let val: any = {}
            val.orderDetailId = payload.details.requestDetailId
            val.response = response
            yield put(setSaveVendorDetails(val));
            yield put(globalLoaderText(""));
        }else{
            yield put(globalLoaderText(""));
            yield put(setSaveVendorDetails(null));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setSaveVendorDetails(null));
    }
}

function* createPODetailsSaga(payload: any): any {
    try {
        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/create/bulkorderpo`,
            payload: payload.orderDetails
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setCreatePODetails({response: response, id: payload.orderDetailId}))
        }else{
            yield put(setCreatePODetails({response: false, id: payload.orderDetailId}))
        }
    } catch (error) {
        yield put(setCreatePODetails({response: false, id: payload.orderDetailId}))
    }
}

function* getBulkFleetHistorySaga(payload: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.OrderManagement,
            endpoint: `orderapproval/order/approval/history/${payload?.OrderRequestId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setBulkFleetHistoryTimeLine(response))
            yield put(globalLoaderText(""));
        }else{
            yield put(setBulkFleetHistoryTimeLine([]))
            yield put(globalLoaderText(""));
        }
        
    } catch (error) {
        yield put(setBulkFleetHistoryTimeLine([]))
        yield put(globalLoaderText(""));
    }
}

function* getBulkOrderFleetAttachmentSaga(payload: any): any {
    try {
        yield put(globalLoaderText("Uploading Attachments ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/update/attachments`,
            payload: payload?.attachmentList
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setBulkOrderFleetAttachments(response))
            yield put(globalLoaderText(""));
        }else{
            yield put(setBulkFleetHistoryTimeLine([]))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setBulkFleetHistoryTimeLine([]))
        yield put(globalLoaderText(""));
    }
}

function* saveBulkOrderFleetBarcode(payload: any): any {
    try {
        yield put(globalLoaderText("Saving Barcode...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.FleetManagement,
            endpoint: `bulkorder/fleet/barcode`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
            yield put(setBulkOrderFleetBarcode({isValid : response}));
            yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setBulkOrderFleetBarcode({validationMessage:'Error occured while saving barcode, please try again', isValid: false, barcodeNo: payload?.payload?.barcodeNo, fleetRequestDetailId: payload?.payload?.fleetDetailId}));
        yield put(globalLoaderText(""));
    }
}

function* watchPurchaseBulkOrder() {
    yield takeEvery(GET_BULK_ORDER_HEADER, getBulkOrderHeader)
    yield takeEvery(GET_BULK_ORDER_FLEET_HEADER, getBulkOrderFleetHeader)
    yield takeEvery(GET_BULK_ORDER_FLEET_PURCHASE_DETAIL, getBulkOrderFleetPurchaseDetail)
    yield takeEvery(SAVE_BULK_ORDER_FLEET_ASSET, saveBulkOrderFleetAsset)
    yield takeEvery(GET_BULK_ORDER_EXCEL_DATA, getBulkOrderExcelData)
    yield takeEvery(GET_TASK_HEADER_DETAILS, getTaskHeaderDetails)
    yield takeEvery(GET_TASK_ITEM_DETAILS, getTaskItemDetails)
    yield takeEvery(SAVE_TASK_ASSIGNED_TO, saveTaskAssignedTo)
    yield takeEvery(SAVE_TASK_COMMENT, saveTaskComment)
    yield takeEvery(SAVE_CANCEL_FLEET_ITEM, saveCancelFleetItem)
    yield takeEvery(GET_BULK_ORDER_DESCRIPTION_DROPDOWN, getBulkOrderDescriptionDropdown)
    yield takeEvery(SAVE_BULK_ORDER_FLEET_PURCHASE_DETAIL, saveBulkOrderFleetPurchaseDetail)
    yield takeEvery(GET_BULK_ORDER_VENDOR_DETAILS, getBulkOrderVendorDetails)
    yield takeEvery(GET_SAVE_VENDOR_DETAILS, getSaveVendorDetails)
    yield takeEvery(GET_BULK_ORDER_PURCHASE_ORDER, getBulkOrderPurchaseOrderSaga)
    yield takeEvery(GET_CREATE_BULK_PO_DETAILS, createPODetailsSaga)
    yield takeEvery(GET_BULK_FLEET_HISTORY_TIMELINE, getBulkFleetHistorySaga)
    yield takeEvery(GET_BULK_ORDER_FLEET_ATTACHMENTS, getBulkOrderFleetAttachmentSaga)
    yield takeEvery(GET_SAVE_BULK_FLEET_PURCHASE_ORDER, saveBulkOrderFleetPurchaseOrder)
    yield takeEvery(SAVE_BULK_ORDER_FLEET_BARCODE, saveBulkOrderFleetBarcode)
    yield takeEvery(SAVE_CANCEL_BULK_ORDER, saveCancelBulkOrder)
    
}

export default function* combinedSaga() {
    yield all([
        watchPurchaseBulkOrder()
    ])
}
